import ListPage from './ListPage.container';
import DetailsPage from './DetailsPage';
import CreatePage from './CreatePage';

export default {
  ListPage,
  CreatePage,
  DetailsPage
};
